const initialState = {
  data: null,
  loading: false,
  error: false,
};

export function cancellationAnalytics(state = initialState, action) {
  switch (action.type) {
    case "CANCELLATION_ANALYTICS_FETCH_DATA_SUCCESS":
      return { ...state, data: action.data, error: false };
    default:
      return state;
  }
}
